import React, { useEffect, useState } from "react";
import { TABLIST } from "../../constants";
import Tabs from "./tabs/Tabs";
import { useDispatch, useSelector } from "react-redux";
import Dropdown from "./Dropdown";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";
import { useTranslation } from "react-i18next";
import ResetForm from "./ResetFrom";
import ResetPasswordForm from "./ResetPasswordForm";
import { setFormType } from "../../auth/authSlice";
import { useMobile } from "../../hooks/use-mobile";
import logo from "../../assets/logos/svg/Garejelebi Logo variations-02.svg";
import TransparentButton from "../../UI/TransparentButton";

const Header = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const isMobile = useMobile();
  const formType = useSelector((state) => state.auth.formType);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const toggleForm = (type) => {
    if (type !== formType) {
      dispatch(setFormType(type));
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > 55 && currentScrollY > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  useEffect(() => {
    if (formType) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = "auto"; // Enable scrolling
    }

    return () => {
      document.body.style.overflow = "auto"; // Reset on unmount
    };
  }, [formType]);

  return (
    <div className="print:hidden">
      <header
        className={`fixed top-0 z-10 w-full bg-baseBlue shadow-header transition-transform duration-500 ${
          isVisible ? "translate-y-0" : "-translate-y-full"
        }`}
      >
        <div className="flex justify-between items-center p-3 md:p-4">
          <div className="min-w-28">
            <a href="/" aria-label="Home">
              <img src={logo} alt="logo" className="h-12" />
            </a>
          </div>
          <nav
            className="flex items-center gap-4 lg:gap-10 "
            aria-label="Main navigation"
          >
            {!isMobile ? (
              <>
                <Tabs tabList={TABLIST} />
                {isAuthenticated ? (
                  !isMobile && <Dropdown options={[]} />
                ) : (
                  <TransparentButton
                    onClick={() => toggleForm("login")}
                    text={t("login")}
                    className="text-[#09263a]!important border-1 border-white hover:text-white hover:bg-baseBlue"
                  />
                )}
              </>
            ) : (
              <div className="flex gap-4 items-center">
                <div className="flex items-center gap-4">
                  {isAuthenticated ? (
                    !isMobile && <Dropdown options={[]} />
                  ) : (
                    <TransparentButton
                      onClick={() => toggleForm("login")}
                      text={t("login")}
                      className="text-[#09263a]!important border-1 border-white hover:text-white hover:bg-baseBlue"
                    />
                  )}
                </div>
                <Dropdown options={TABLIST} />
              </div>
            )}
          </nav>
        </div>
      </header>
      {formType === "login" && <LoginForm toggleForm={toggleForm} />}
      {formType === "register" && <RegisterForm toggleForm={toggleForm} />}
      {formType === "reset" && <ResetForm toggleForm={toggleForm} />}
      {formType === "resetPassword" && <ResetPasswordForm toggleForm={toggleForm} />}
    </div>
  );
};

export default Header;
